import { TranslationKey } from "../../translations/TranslationKey";

export enum CandidateModuleState {
  None = "None",
  ApplicationAccepted = "ApplicationAccepted",
  VerificationRequired = "VerificationRequired",
  Passed = "Passed",
  Failed = "Failed",
  Cancelled = "Cancelled",
  Expired = "Expired",
  Equivalence = "Equivalence",
}

export const CandidateModuleStateTranslationKey: { [state in CandidateModuleState]: TranslationKey | undefined } = {
  [CandidateModuleState.None]: undefined,
  [CandidateModuleState.ApplicationAccepted]: "examSessionCandidateModuleState.applicationAccepted",
  [CandidateModuleState.VerificationRequired]: "examSessionCandidateModuleState.verificationRequired",
  [CandidateModuleState.Passed]: "examSessionCandidateModuleState.passed",
  [CandidateModuleState.Failed]: "examSessionCandidateModuleState.failed",
  [CandidateModuleState.Cancelled]: "examSessionCandidateModuleState.cancelled",
  [CandidateModuleState.Expired]: "examSessionCandidateModuleState.expired",
  [CandidateModuleState.Equivalence]: "examSessionCandidateModuleState.equivalence",
};
